import { CommandList } from "~/core/ui/Command";
import If from "~/core/ui/If";

import { useGlobalCommandbarStore } from "../../store";

import CommandsSection from "./CommandsSection";
import LoadingCommandbarItems from "./Loading";
import MeetingSection from "./MeetingSection";
import NoResult from "./NoResult";
import PagesSection from "./PagesSection";
import RecordsSection from "./RecordsSection";

export default function CommandbarContent() {
  const commandbarSearchItems = useGlobalCommandbarStore(
    st => st.commandbarSearchItems,
  );
  const commandbarPageItems = useGlobalCommandbarStore(
    st => st.commandbarPageItems,
  );
  const commandbarCommandItems = useGlobalCommandbarStore(
    st => st.commandbarCommandItems,
  );
  const loadingCommandbarItems = useGlobalCommandbarStore(
    st => st.loadingCommandbarItems,
  );

  return (
    <CommandList className="p-3 max-h-[400px] overflow-y-auto">
      <If
        condition={
          commandbarCommandItems.length !== 0 ||
          commandbarPageItems.length !== 0 ||
          commandbarSearchItems.length !== 0
        }
        fallback={
          <If condition={loadingCommandbarItems} fallback={<NoResult />}>
            <LoadingCommandbarItems />
          </If>
        }
      >
        <CommandsSection />
        <MeetingSection />
        <PagesSection />
        <RecordsSection />
      </If>
    </CommandList>
  );
}
